import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-upload-text" }
const _hoisted_2 = { class: "text-grey" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ant_icon = _resolveComponent("ant-icon")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_img_cropper = _resolveComponent("img-cropper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, {
      "before-upload": _ctx.beforeUpload,
      "custom-request": _ctx.customRequest,
      disabled: _ctx.disabled,
      fileList: _ctx.fileList,
      multiple: true,
      onRemove: _ctx.onRemove,
      accept: ".jpg,.png,.jpeg",
      class: "hmd-btn",
      "list-type": "picture-card",
      name: "file",
      onPreview: _ctx.onPreview
    }, {
      default: _withCtx(() => [
        (!_ctx.disabled && _ctx.fileList.length < _ctx.maxCount)
          ? (_openBlock(), _createBlock(_component_a_spin, {
              key: 0,
              spinning: _ctx.uploading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ant_icon, { type: "PlusOutlined" }),
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.buttonText), 1)
              ]),
              _: 1
            }, 8, ["spinning"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["before-upload", "custom-request", "disabled", "fileList", "onRemove", "onPreview"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tip), 1),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.previewVisible,
      onCancel: _ctx.closePreviewModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.previewUrl,
          style: {"width":"100%"}
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"]),
    (_ctx.cropperVisible)
      ? (_openBlock(), _createBlock(_component_img_cropper, {
          key: 0,
          image: _ctx.cropperUrl,
          cropperInfo: _ctx.cropperInfo,
          onCloseCropper: _ctx.closeCropper,
          onSaveCropper: _ctx.saveCropper
        }, null, 8, ["image", "cropperInfo", "onCloseCropper", "onSaveCropper"]))
      : _createCommentVNode("", true)
  ]))
}